import Vue from 'vue';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
// Docs: https://vcalendar.io/attributes.html#attribute-types

import {
  SlotPickerMobile,
} from '@/components';

import calenderIcon from '@/assets/images/icons/calender.svg';
import editIcon from '@/assets/images/icons/edit.svg';

import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

import {
  api,
} from '@/utils';

export default {
  name: 'DateMobilePickerRegion',
  components: {
    DatePicker,
    [SlotPickerMobile.name]: SlotPickerMobile,
    calenderIcon,
    editIcon,
  },
  props: {},
  data: () => ({
    isOpen: false,
    slotsPickerIsActive: false,
    // Slots from the backend
    slots: [],
    slotHours: [],
    // Selected date in c# format
    selectedDate: null,
    // Month & year to get the slots
    month: 0,
    year: 0,
    // Date where the calender starts
    fromDate: new Date(),
    // Amount of times we try to gets
    tryToGetSlots: 3,
    // These are the pages on the calendar we already visited
    visitedPages: [],
    attributes: [{
      dot: {
        color: 'red',
        class: 'my-dot-class',
      },
      dates: [],
    }],

  }),
  computed: {
    ...mapGetters('appointment', {
      licensePlate: 'getLicensePlate',
      personalData: 'getPersonalData',
      addressId: 'getAddressId',
      vehiculeType: 'getVehiculeType',
      serviceType: 'getServiceType',
      slotNumber: 'getSlotNumber',
      date: 'getDate',
      hour: 'getHour',
      errorSlot: 'getErrorSlot',
      company: 'getCompany',
    }),
    language() {
      return Vue.config.language.replace('_', '-');
    },
    // Model that is bind to date-picker
    datePickerModel: {
      get() {
        return this.selectedDate;
      },
      set(value) {
        this.selectedDate = value;

        if (value !== null) {
          this.openSlotsPicker();
        }
      },
    },
    availableDates() {
      const availableDates = this.slots.map(s => s.date);
      return availableDates;
    },
    availableSlots() {
      const selectedDateLocal = this.$options.filters.formatDateLocal(this.datePickerModel);
      const datum = selectedDateLocal.split('T')[0];
      // console.log(datum);
      const findAvailableSlots = this.slots
        .find(s => s.date === datum);

      // console.log(findAvailableSlots);

      if (findAvailableSlots === undefined) {
        this.setSloteDate('');
      }

      return findAvailableSlots != null ? findAvailableSlots : undefined;
    },
    datePickerAttributes() {
      return [{
        highlight: {
          color: 'green',
          fillMode: 'none',
        },
        dates: this.availableDates,
      }];
    },
    showDateNotAvailableErrorMessage() {
      return this.selectedDate !== null && this.availableSlots?.freeplaces <= 0;
    },
  },
  methods: {
    ...mapActions('appointment', {
      setSlotNumber: 'SET_SLOTNUMBER_MOBILE_BUS',
    }),
    ...mapMutations('appointment', {
      setSloteDate: 'APPEND_RESERVATION_MOBILE_COMP',
    }),
    fetchSlots() {
      if (this.addressId !== '') {
        api.get(`/address/getdatesmobile?address=${this.addressId}`)
          .then(response => {
            // console.log(response.data?.dateList);
            this.slots = response.data?.dateList;
            // If slots are empty we go to the next page in the datepicker,
            // This triggers changePage runs fetchSlots() again
            if (this.slots.length === 0 && this.tryToGetSlots > 0) {
              this.year = this.month === 12 ? this.year + 1 : this.year;
              this.month = this.month === 12 ? 1 : this.month + 1;
              this.fromDate = new Date(this.year, this.month - 1, 1);
              this.tryToGetSlots -= 1;
            }
          }).catch(() => {
            // console.log(e);
          });
      }
    },
    changePage(page) {
      if (this.visitedPages.find(vp => vp.month === page.month && vp.year === page.year) == null) {
        this.month = page.month;
        this.year = page.year;
        this.visitedPages.push(page);
        this.fetchSlots();
      }
    },
    openPopup() {
      if (this.addressId !== '') {
        this.isOpen = true;
        document.getElementById('app').style.overflow = 'hidden';
      }
    },
    closePopup() {
      this.isOpen = false;
      document.getElementById('app').style.overflow = 'unset';
    },
    openSlotsPicker() {
      if (!this.showDateNotAvailableErrorMessage) {
        this.slotsPickerIsActive = true;
      }
    },
    closeSlotsPicker(availableSlot) {
      // console.log(availableSlot);
      if (availableSlot != null) {
        // const dateForBackend = this.$options.filters.formatDateBackend(this.selectedDate);

        // console.log(dateForBackend);

        this.setSloteDate(availableSlot);
        this.slotsPickerIsActive = false;
        this.closePopup();

        // // NEED TO CHANGE TO NEW MODEL (REQUEST)
        // const reservationRequestModel = {
        //   licenseplate: this.licensePlate,
        //   addressId: this.addressId,
        //   date: dateForBackend,
        //   slotNumber: this.slotNumber,
        //   company: this.company,
        // };

        // // console.log(reservationRequestModel);

        // this.setSlotNumber(reservationRequestModel)
        //   .then(() => {
        //     if (!this.errorSlot) {
        //       this.slotsPickerIsActive = false;
        //       this.closePopup();
        //     }
        //   });
      } else {
        this.slotsPickerIsActive = false;
      }
    },
  },
  watch: {
    addressId: function () {
      this.month = 0;
      this.year = 0;
      this.selectedDate = null;
      this.visitedPages = [];
      this.slots = [];
    },
  },
};
